import { Link } from 'react-router-dom';
import { nextLearningSteps } from '@/mocks/mt4mt5Page';

export default function NextLearning() {
  return (
    <section className="bg-primary-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[380px_1fr] lg:items-start lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-700">
              <span className="h-px w-6 bg-accent-500" />
              เส้นทางการเรียนรู้
            </span>
            <h2 className="mt-3 text-balance font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-[32px]">
              เริ่มต้นเรียนรู้ Forex อย่างเป็นระบบ
            </h2>
            <p className="mt-3.5 text-sm leading-relaxed text-foreground-700">
              นอกจากการใช้งาน MT4 และ MT5 แล้ว คุณยังสามารถเรียนรู้พื้นฐาน Forex วิธีการเทรด การวิเคราะห์ตลาด
              และการบริหารความเสี่ยงเพิ่มเติมได้
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {nextLearningSteps.map((step) => (
              <Link
                key={step.path}
                to={step.path}
                className="group flex h-full cursor-pointer flex-col rounded-xl border border-primary-100 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${step.icon} text-lg`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold leading-snug text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{step.description}</p>
                <span className="mt-4 flex items-center justify-between gap-2 border-t border-background-200 pt-3 text-xs font-medium text-foreground-500">
                  <span>{step.meta}</span>
                  <i className="ri-arrow-right-line text-base text-primary-600 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}